<div mat-dialog-title>
  <h2>Processo Seletivo</h2>
  <span
    *ngIf="currentProcessList.candidateStatus === 'hired'"
    class="mat-body-2 hired-message"
    style="color: #093"
    >Parabéns, você foi contratado</span
  >
</div>

<mat-dialog-content>
  <ng-template #infoStep>
    <h3>Informações da Oportunidade</h3>
    <h4>Processo Seletivo: {{ currentProcessList.name }}</h4>
    <form [formGroup]="form" style="margin-top: 20px">
      <div class="row" *ngIf="currentProcessList.viewname === 'true'">
        <mat-form-field appearance="outline">
          <mat-label>Nome da Empresa</mat-label>
          <input
            type="text"
            matInput
            placeholder="Nome fantasia da empresa"
            formControlName="companyname"
            [readonly]="true"
          />
        </mat-form-field>
      </div>
      <div class="row" *ngIf="currentProcessList.viewtel === 'true'">
        <mat-form-field appearance="outline">
          <mat-label>Telefone</mat-label>
          <input
            matInput
            type="phone"
            placeholder="Informe o número de telefone"
            mask="(00) 00000 0000"
            formControlName="phone"
            inputmode="numeric"
            [readonly]="true"
          />
        </mat-form-field>
      </div>
      <fieldset style="margin-top: 10px">
        <legend style="font-size: 14px">Localização</legend>

        <div class="row">
          <mat-form-field
            appearance="outline"
            *ngIf="currentProcessList.viewend === 'true'"
          >
            <mat-label>CEP</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe seu cep"
              autocomplete="off"
              formControlName="zipCode"
              mask="00000-000"
              inputmode="numeric"
              [readonly]="true"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Estado</mat-label>
            <mat-autocomplete
              #autoState="matAutocomplete"
              [displayWith]="displayState"
              (optionSelected)="onStateSelected($event)"
            >
              <ng-container *ngFor="let state of filteredStates$ | async">
                <mat-option [value]="state">{{ state.nome }}</mat-option>
              </ng-container>
            </mat-autocomplete>
            <input
              matInput
              type="text"
              placeholder="Informe o estado"
              autocomplete="off"
              formControlName="state"
              [matAutocomplete]="autoState"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Cidade</mat-label>
            <mat-autocomplete #autoCity="matAutocomplete">
              <ng-container *ngFor="let city of filteredCities$ | async">
                <mat-option [value]="city.name">{{ city.name }}</mat-option>
              </ng-container>
            </mat-autocomplete>
            <input
              matInput
              type="text"
              placeholder="Informe a cidade"
              autocomplete="off"
              formControlName="city"
              [matAutocomplete]="autoCity"
              [readonly]="true"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Bairro</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe seu bairro"
              autocomplete="off"
              formControlName="district"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="currentProcessList.viewend === 'true'">
          <mat-form-field appearance="outline">
            <mat-label>Rua/avenida</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe a rua/avenida"
              autocomplete="off"
              formControlName="street"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="currentProcessList.viewend === 'true'">
          <mat-form-field appearance="outline">
            <mat-label>Número</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe o numero"
              autocomplete="off"
              formControlName="number"
              inputmode="numeric"
              [readonly]="true"
            />
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            *ngIf="currentProcessList.viewend === 'true'"
          >
            <mat-label>Complemento</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe o complemento"
              autocomplete="off"
              formControlName="complement"
              [readonly]="true"
            />
          </mat-form-field>
        </div>
      </fieldset>

      <fieldset>
        <legend style="font-size: 14px">Detalhes do Serviço</legend>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Regime de contratação</mat-label>
            <mat-select
              placeholder="Selecione uma opção"
              formControlName="workregime"
              [disabled]="true"
            >
              <mat-option value="CLT">CLT</mat-option>
              <mat-option value="PJ">PJ</mat-option>
              <mat-option value="Freelancer">Freelancer</mat-option>
              <mat-option value="Temporário">Temporário</mat-option>
              <mat-option value="Outros">Outros</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Modelo de trabalho</mat-label>
            <mat-select
              placeholder="Selecione uma opção"
              formControlName="modalityjob"
              [disabled]="true"
            >
              <mat-option value="Presencial">Presencial</mat-option>
              <mat-option value="Home Office">Home Office</mat-option>
              <mat-option value="Híbrido">Híbrido</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Cargo</mat-label>
            <input
              type="text"
              id="Sinonimo"
              placeholder="Cargo"
              matInput
              formControlName="sinonimo"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Moeda</mat-label>
            <mat-select
              placeholder="Selecione uma opção"
              formControlName="coin"
              [disabled]="true"
            >
              <mat-option value="BRL">BRL (R$)</mat-option>
              <mat-option value="USD">USD ($)</mat-option>
              <mat-option value="EUR">EUR (€)</mat-option>
              <mat-option value="GBP">GBP (£)</mat-option>
              <mat-option value="JPY">JPY (¥)</mat-option>
              <mat-option value="AUD">AUD (A$)</mat-option>
              <mat-option value="CAD">CAD (C$)</mat-option>
              <mat-option value="CHF">CHF (CHF)</mat-option>
              <mat-option value="CNY">CNY (¥)</mat-option>
              <mat-option value="SEK">SEK (kr)</mat-option>
              <mat-option value="NZD">NZD (NZ$)</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Salário</mat-label>
            <!-- <input
              matInput
              type="text"
              placeholder="Informe o valor"
              mask="separator.2"
              thousandSeparator="."
              inputmode="numeric"
              formControlName="salary"
              [readonly]="true"
            /> -->
            <input matInput type="text" placeholder="Informe um valor ou 0 para (à combinar)" [formControl]="form.get('salary')"
                (input)="formatMoneyInput($event)" id="salary" />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Dias</mat-label>
            <input
              matInput
              type="text"
              formControlName="daysWeek"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="diaEstaPresente('monday')">
          <mat-form-field appearance="outline">
            <mat-label>Início da Jornada de Trabalho</mat-label>
            <input
              type="time"
              matInput
              formControlName="start_monday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label>Fim da Jornada de Trabalho</mat-label>
            <input
              type="time"
              matInput
              formControlName="end_monday"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <!-- <div class="row" *ngIf="diaEstaPresente('tuesday')">
          <mat-form-field appearance="outline">
            <mat-label
              >Início da Jornada de Trabalho ({{
                getDiaSemana2("tuesday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="start_tuesday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label
              >Fim da Jornada de Trabalho ({{
                getDiaSemana2("tuesday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="end_tuesday"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="diaEstaPresente('wednesday')">
          <mat-form-field appearance="outline">
            <mat-label
              >Início da Jornada de Trabalho ({{
                getDiaSemana2("wednesday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="start_wednesday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label
              >Fim da Jornada de Trabalho ({{
                getDiaSemana2("wednesday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="end_wednesday"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="diaEstaPresente('thursday')">
          <mat-form-field appearance="outline">
            <mat-label
              >Início da Jornada de Trabalho ({{
                getDiaSemana2("thursday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="start_thursday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label
              >Fim da Jornada de Trabalho ({{
                getDiaSemana2("thursday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="end_thursday"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="diaEstaPresente('friday')">
          <mat-form-field appearance="outline">
            <mat-label
              >Início da Jornada de Trabalho ({{
                getDiaSemana2("friday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="start_friday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label
              >Fim da Jornada de Trabalho ({{
                getDiaSemana2("friday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="end_friday"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="diaEstaPresente('saturday')">
          <mat-form-field appearance="outline">
            <mat-label
              >Início da Jornada de Trabalho ({{
                getDiaSemana2("saturday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="start_saturday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label
              >Fim da Jornada de Trabalho ({{
                getDiaSemana2("saturday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="end_saturday"
              [readonly]="true"
            />
          </mat-form-field>
        </div>

        <div class="row" *ngIf="diaEstaPresente('sunday')">
          <mat-form-field appearance="outline">
            <mat-label
              >Início da Jornada de Trabalho ({{
                getDiaSemana2("sunday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="start_sunday"
              [readonly]="true"
            />
          </mat-form-field>
          <p class="until">até</p>
          <mat-form-field appearance="outline">
            <mat-label
              >Fim da Jornada de Trabalho ({{
                getDiaSemana2("sunday")
              }})</mat-label
            >
            <input
              type="time"
              matInput
              formControlName="end_sunday"
              [readonly]="true"
            />
          </mat-form-field>
        </div> -->

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Beneficios</mat-label>
            <textarea
              matInput
              placeholder="descreva os beneficios EX: VT VR VA"
              formControlName="benefits"
              rows="5"
              maxlength="1000"
              [readonly]="true"
            ></textarea>
          </mat-form-field>
        </div>

        <div class="row" style="margin-top: 10px">
          <mat-form-field appearance="outline">
            <mat-label>Requisitos</mat-label>
            <textarea
              matInput
              placeholder="informe os requisitos para vaga"
              formControlName="requirements"
              rows="5"
              maxlength="1000"
              [readonly]="true"
            ></textarea>
          </mat-form-field>
        </div>

        <div class="row" style="margin-top: 10px">
          <mat-form-field appearance="outline">
            <mat-label>Atividades a serem desempenhadas</mat-label>
            <textarea
              matInput
              placeholder="descreva as atividades a serem desempenhadas"
              formControlName="activities"
              rows="5"
              maxlength="1000"
              [readonly]="true"
            ></textarea>
          </mat-form-field>
        </div>
      </fieldset>
    </form>
  </ng-template>
  <ng-template #testStep>
    <mat-action-list>
        <button
          mat-list-item
          *ngFor="let test of tests"
          (click)="openQuestions(test)"
        >
          <h3 matLine>{{ test.name }}</h3>
          <p matLine>{{ test.created_at | date : "dd/MM/yyyy hh:mm" }}</p>
          <span class="status">
            <span class="punctuation" *ngIf="test.status === 'evaluated'">
             {{ questionsPunctuation[test.id]?.right_options.total }} / {{ questionsPunctuation[test.id]?.all_options.total }}
            </span>
            <span class="note">
              {{ getTestStatus(test.status) }}
            </span>
          </span>
        </button>
    </mat-action-list>

    <ng-container *ngIf="tests.length === 0">
      <div class="empty-content">
        <span class="mat-body-2"> Sem testes para fazer no momento </span>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #interviewStep>
    <mat-list>
      <!--<mat-list-item *ngFor="let interview of interviews">
        <h3 matLine>
          Começa as {{ interview.date_start | date : "dd/MM/yyyy" }} as
          {{ formatTime(interview.time_start) }}
        </h3>
        <p matLine style="margin-bottom: 0;"> Tipo: {{ interview.type === 'true' ? 'Entrevista Remota' : 'Entrevista Presencial' }}</p>
        <span matLine *ngIf="interview.type === 'false'">{{ interview.address }}</span>
        <span matLine>Falar com {{ interview.contact }}</span>
        <span matLine>
          <ng-container *ngIf="interview.link_meet && interview.accept == 1">
            Abrir Link da Entrevista Online:
            <a [href]="interview.link_meet" target="_blank" rel="noopener noreferrer" 
               (click)="checkDateAndConfirm($event, interview.date_start, interview.time_start)">
              <button color="primary" mat-icon-button matTooltip="Acesse agora clicando aqui!">
                <mat-icon>videocam</mat-icon>
              </button>
            </a>
          </ng-container>
        </span>
        <span matLine *ngIf="interview.accept === null">
          <small>Aceita agendar essa entrevista?</small>
          <div>
            <button
              mat-stroked-button
              color="primary"
              style="margin-right: 5px"
              (click)="saveUserInterview(interview, true)"
            >
              Aceitar
            </button>
            <button
              mat-stroked-button
              color="warn"
              (click)="saveUserInterview(interview, false)"
            >
              Rejeitar
            </button>
          </div>
        </span>
        <span matLine>
          <ng-container *ngIf="interview.points == 0">
            <span *ngIf="interview.accept == 1" style="color: #09c"
              >Agendou a entrevista</span
            >

            <span *ngIf="interview.accept == 0" style="color: red"
              >Rejeitou a entrevista</span
            >
          </ng-container>

          <ng-container *ngIf="interview.points > 0">
            <span *ngIf="interview.accept == 1" style="color: #093"
              >Pontuação da entrevista: {{ interview.points }}</span
            >
          </ng-container>
        </span>
      </mat-list-item> -->
      <ng-container *ngIf="interviews?.length > 0">
        <div class="calendar-instructions">
          <p>
            📅 Use o calendário ou a lista 'Outras Entrevistas' para visualizar e acessar os detalhes das suas entrevistas.
          </p>
        </div>
        <div class="calendar-container">
          <div class="calendar-sidebar">
            <h4>Outras Entrevistas</h4>
            <ul>
              <li *ngFor="let event of events">
                <button (click)="abrirEntrevista(event)" class="event-button">
                  <span>Ir para:</span>
                  <span *ngIf="event.extendedProps.status === 'pendente'" class="icon">⚠️</span>
                  <span class="title">{{ event.title }}</span>
                  <small class="date">
                    {{ event.start | date: 'dd/MM/yyyy' }} às {{ event.start | date: 'HH:mm' }}
                  </small>
                </button>
              </li>
            </ul>
          </div>
        
          <div class="calendar-main">
            <full-calendar
              #fullcalendar
              [options]="calendarOptions"
              [events]="events"
              ></full-calendar>
          </div>
        </div>
      </ng-container>
    </mat-list>

    <ng-container *ngIf="interviews?.length === 0">
      <div class="empty-content">
        <span class="mat-body-2"> Sem entrevista para marcar no momento </span>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #statusStep>
    <div class="status-wrapper">
      <ng-container
        *ngIf="currentProcessList.status !== 'finished'; else finishedStatus"
      >
        <span class="mat-title"> Processo ainda não foi terminado </span>
      </ng-container>
      <ng-template #finishedStatus>
        <span class="mat-title"> Processo terminado </span>
        <span
          class="mat-title"
          style="color: #093"
          *ngIf="currentProcessList.candidateStatus === 'hired'"
          >Parabéns, você foi contratado</span
        >
      </ng-template>
    </div>
  </ng-template>

  <mat-vertical-stepper
    [linear]="false"
    #interviewStepper
    *ngIf="isSmallScreen$ | async; else largeStepper"
  >
    <ng-container *ngIf="showinfo">
      <mat-step label="Informações">
        <ng-container *ngTemplateOutlet="infoStep"></ng-container>
      </mat-step>
    </ng-container>
    <mat-step [completed]="isCompletedTest()" label="Testes">
      <ng-container *ngTemplateOutlet="testStep"></ng-container>
    </mat-step>
    <mat-step label="Entrevista" [completed]="isCompletedInterview()">
      <ng-container *ngTemplateOutlet="interviewStep"></ng-container>
    </mat-step>
    <mat-step label="Status">
      <ng-container *ngTemplateOutlet="statusStep"></ng-container>
    </mat-step>
  </mat-vertical-stepper>

  <ng-template #largeStepper>
    <mat-horizontal-stepper [linear]="false" #interviewStepper>
      <ng-container *ngIf="showinfo">
        <mat-step label="Informações">
          <ng-container *ngTemplateOutlet="infoStep"></ng-container>
        </mat-step>
      </ng-container>
      <mat-step [completed]="isCompletedTest()" label="Testes">
        <ng-container *ngTemplateOutlet="testStep"></ng-container>
      </mat-step>
      <mat-step label="Entrevista" [completed]="isCompletedInterview()">
        <ng-container *ngTemplateOutlet="interviewStep"></ng-container>
      </mat-step>
      <mat-step label="Status">
        <ng-container *ngTemplateOutlet="statusStep"></ng-container>
      </mat-step>
    </mat-horizontal-stepper>
  </ng-template>
</mat-dialog-content>
<mat-progress-bar
  color="primary"
  mode="indeterminate"
  *ngIf="submiting"
></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
  <button color="accent" mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>
